// src/pages/settings/SettingsControls.tsx
import { Input as ChakraInput, type InputProps } from '@chakra-ui/react'

export function SettingsInput(props: InputProps) {
  return <ChakraInput {...props} />
}
